import { UsersQueries } from '@frontend/api-users';

export const useAssigneeByLocation = (locationIds: string[]) => {
  return UsersQueries.useGetUsersInLocations(locationIds);
};
